import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from '../../services/notifications.service';
import { CommonBindingDataService } from '../../services/common-binding-data.service';

@Component({
  selector: 'app-notification-mg1',
  templateUrl: './notification-mg1.component.html'
})
export class NotificationMG1Component implements OnInit {
  limit = 10;
  offset = 0;
  notificationdata: any;
  notificationlist: any = [];

  constructor(private notificationsService: NotificationsService,
    private router: Router,
    private commonBindingDataService: CommonBindingDataService) {
    this.commonBindingDataService.setTitle(this.commonBindingDataService.getLabel('label_header_notification'));
  }

  ngOnInit() {
    this.getNotificationList();
  }

  getNotificationList() {
    this.notificationsService.getDetails(1, this.limit, this.offset, 1).subscribe(result => {
      this.notificationdata = result.notificationList;
      this.notificationlist = result.notificationList;
    });
  }

  redirectTo(data) {
    const notificationType = data.extraParams.split('~')[0];
    if (notificationType === 'TNMDA') {
      this.router.navigate(['admin-chat']);
    }
  }

  replaceURLWithHTMLLinks(text) {
    const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(exp, `<a class="external-link" href='$1' target='_blank'>$1</a>`);
  }

  onScroll() {
    if (this.notificationdata.length > 0) {
      this.offset = this.offset + 10;
      this.notificationsService.getDetails(1, this.limit, this.offset, 1).subscribe(result => {
        this.notificationdata = result.notificationList;
        this.notificationlist = [...this.notificationlist, ...result.notificationList];
      });
    }
  }
}
